import React from 'react';
import PropTypes from 'prop-types';
import { Message } from '@fasstech/middle-design-system';

const ExtraDownloadContainer = ({ hasError, downloadMandatory }) => {
  return (
    <>
      {hasError && (
        <Message variant="error" className="mb-2">
          {downloadMandatory
            ? 'Votre document (devis et dossier d’adhésion) n’a pas pu être généré, merci de réessayer ultérieurement.'
            : 'Votre document (devis et dossier d’adhésion) n’a pas pu être généré. Vous pouvez néanmoins poursuivre votre adhésion.'}
        </Message>
      )}
    </>
  );
};

ExtraDownloadContainer.propTypes = {
  hasError: PropTypes.bool,
  downloadMandatory: PropTypes.bool
};

export default ExtraDownloadContainer;
